import { Shift } from "./shift";

export class Attendance {
    _id: string = '';
    created_at: string = '';
    updated_at: string = '';
    brand_id: string = '';
    branch_id: string = '';
    branch_name: string = '';
    employee_id: string = '';
    employee_update_id: string = '';
    shift_id: string = '';
    check_in_time: string = ''; // Format: DD/MM/YYYY HH:mm
    check_out_time: string = ''; // Format: DD/MM/YYYY HH:mm
    late_minutes: number = 0;
    early_minutes: number = 0;
    date: string = ''; // Format: DD/MM/YYYY
    check_in_lat: number = 0;
    check_in_lng: number = 0;
    check_out_lat: number = 0;
    check_out_lng: number = 0;
    reason: string = '';
    shift: Shift = new Shift();
    employee: ShiftEmployee = new ShiftEmployee();
    employee_update: ShiftEmployee = new ShiftEmployee();

    constructor(data?: Partial<Attendance>) {
        Object.assign(this, data);
    }
}

export class ShiftEmployee {
    employee_id: string = '';
    employee_name: string = '';
    employee_avatar: string = '';

    constructor(data?: Partial<ShiftEmployee>) {
        Object.assign(this, data);
    }
}
